import { navigateTo } from 'gatsby-link'
import * as React from 'react'
import * as ReactTooltip from 'react-tooltip'
import Header from '../components/Header'
import MailingListModal from '../components/MailingListModal'
import Overlay from '../components/Overlay'
import PrimaryButton from '../components/PrimaryButton'
import { GASendEvent } from '../ga'

interface IState {
  mailingOverlayVisible: boolean
  storedTo: string
}

class IndexPage extends React.PureComponent<null, IState> {
  public state: IState = {
    mailingOverlayVisible: false,
    storedTo: '',
  }

  public cardClickHandler = (e: React.MouseEvent<HTMLElement>, to: string) => {
    // Skip the card and just navigate if we've already gone through the mailing list modal
    if (sessionStorage.getItem('completed_mailinglist') === 'true') {
      navigateTo(to)
      return
    }

    GASendEvent('mailinglist', 'popup')

    this.setState({ mailingOverlayVisible: true, storedTo: to })
  }

  public cardClickHandlerWrapper = (to: string) => () => {
    this.cardClickHandler(null, to)
  }

  public closeCallback = () => {
    this.setState({ mailingOverlayVisible: false })
    sessionStorage.setItem('completed_mailinglist', 'true')
  }

  public skipCallback = () => {
    const { storedTo } = this.state

    if (storedTo !== null) {
      navigateTo(storedTo)
      sessionStorage.setItem('completed_mailinglist', 'true')
    }
  }

  public render() {
    const { mailingOverlayVisible } = this.state

    return (
      <div className="app">
        <Overlay
          visible={mailingOverlayVisible}
          closeCallback={this.closeCallback}
        >
          <MailingListModal
            type={'overlay'}
            closeCallback={this.closeCallback}
            skipCallback={this.skipCallback}
          />
        </Overlay>
        <ReactTooltip className="tooltip" place="bottom" effect="solid" aria-haspopup="true" />
        <div className="home__backdrop__gradient" />
        <div className="page">
          <Header />
          {/* <div className="betanotice">We're currently in beta, meaning we're constantly looking for feedback!</div> */}
          <section className="home__hero">
            <h1 className="big_title home__hero__title">
              {/* We help you get through <mark>tough</mark> talks */}
              We help build solid <mark>friendships and love</mark>.
            </h1>
            <p className="home__hero__description">
              <strong className="about__name">Supportive</strong> is a
              collection of{' '}
              <strong className="about__name">
                <em
                  className="tooltip__text"
                  data-tip="Supportive is completely free, with no strings attached."
                >
                  free
                </em>
              </strong>{' '}
              audio conversations to solve nagging problems and find deeper
              connections.
            </p>
          </section>
          <div className="home__arrows" />
          <section className="home__cards">
            <div className="home__card theme--green">
              <div className="home__card__backdrop__gradient" />
              <div className="home__card__content">
                <div className={`module__icon--deeper`} />
                <h1 className="small_title">We want to have a deeper talk.</h1>
                <p className="normal_paragraph">
                  This guided conversation helps you find{' '}
                  <mark>meaningful discussion</mark> when it’s hard to start.
                </p>
                <PrimaryButton
                  className="home__card__button"
                  text="Let's get deep"
                  callback={this.cardClickHandlerWrapper('modules/deeper')}
                />
              </div>
            </div>
            <div className="home__card theme--yellow">
              <div className="home__card__backdrop__gradient" />
              <div className="home__card__content">
                <div className={`module__icon--argument`} />
                <h1 className="small_title">We’re having an argument.</h1>
                <p className="normal_paragraph">
                  This guided conversation helps you find{' '}
                  <mark>mutual ground</mark> and move forward from a fight.
                </p>
                {/* <PrimaryButton
                  className="home__card__button"
                  text="Let's settle things"
                  to="modules/argument"
                /> */}
                <div className="home__coming__soon__button">Coming Soon</div>
              </div>
            </div>
            <div className="home__card theme--red">
              <div className="home__card__backdrop__gradient" />
              <div className="home__card__content">
                <div className={`module__icon--hurt`} />
                <h1 className="small_title">We said something hurtful.</h1>
                <p className="normal_paragraph">
                  This guided conversation helps you{' '}
                  <mark>express your feelings fairly</mark>, find peace, and
                  heal.
                </p>
                {/* <PrimaryButton disabled className="home__card__button" text="Let's talk" to="modules/argument" /> */}
                <div className="home__coming__soon__button">Coming Soon</div>
              </div>
            </div>
            <div className="home__card theme--orange">
              <div className="home__card__backdrop__gradient" />
              <div className="home__card__content">
                <div className={`module__icon--expectations`} />
                <h1 className="small_title">We want to set expectations.</h1>
                <p className="normal_paragraph">
                  This guided conversation helps you find and set{' '}
                  <mark>expectations</mark> with your partner.
                </p>
                {/* <PrimaryButton disabled={true} className="home__card__button" text="Let's figure this out" to="modules/argument" /> */}
                <div className="home__coming__soon__button">Coming Soon</div>
              </div>
            </div>
          </section>
          <section className="home__how">
            <div className="home__how__header">
              <h1 className="small_title">How does it work?</h1>
              <p className="normal_paragraph">
                Supportive makes it easy to have conversations that are equal,
                respectful, and deep.
              </p>
            </div>
            <ol className="home__how__list">
              <li>
                <img src={require('../img/howto1.svg')} alt="" />
                <p>Get together with your partner.</p>
              </li>
              <li>
                <img src={require('../img/howto2.svg')} alt="" />
                <p>Decide which topic you both want to explore.</p>
              </li>
              <li>
                <img src={require('../img/howto3.svg')} alt="" />
                <p>Have a conversation, guided by Supportive audio.</p>
              </li>
            </ol>
          </section>
          <section className="home__mailinglist">
            <MailingListModal />
          </section>
          <div className="about__torch">
            <img
              className="about__torch__img"
              src={require('../img/torch.svg')}
              alt=""
            />
            <img
              className="about__torch__arrow"
              src={require('../img/torch__arrow.svg')}
              alt=""
            />
            <p className="about__torch__text tiny_subtext">
              As long as this torch is lit, we're actively making Supportive!
            </p>
          </div>
        </div>
      </div>
    )
  }
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.tsx